import React, { useEffect, useRef, useState } from "react";
import './autocomplete.css'

export interface IAutoCompleteProps {
  data: any;
  name: string;
  placeholder?: string;
  label?: string;
  touched?: false;
  initialValue?: any;
  value?: any;
  handleChange?: any;
}

export const Autocomplete: React.FC<IAutoCompleteProps> = ({ data, name, handleChange, value, initialValue, placeholder, label, touched }: any) => {

  const inputRef = useRef<HTMLInputElement | null>(null);
  const autocompleteRef = useRef<HTMLUListElement | null>(null);

  const [active, setActive] = useState(0);
  const [filtered, setFiltered] = useState<any[]>([]);
  const [isShow, setIsShow] = useState(false);

  useEffect(()=> {
    const hideAutoComplete = () => {
      setIsShow(false);
    }
    window.addEventListener('click',hideAutoComplete);

    return () => {
      window.removeEventListener('click',hideAutoComplete);
    }
  },[])

  useEffect(()=> {
    setFiltered(data);
  },[data])

  const onChange = (e: any) => {
    
    const suggestions = data;
    
    const userInput = e.currentTarget.value;

    if (handleChange) handleChange(e);
    let newFilteredSuggestions =[];
    if(userInput!=""){
     newFilteredSuggestions = suggestions ? suggestions.filter(
      (suggestion: string) =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) == 0
       
    ) : [];
    }
   
    setActive(0);
    setFiltered(newFilteredSuggestions);
    setIsShow(true);

  };

  const changeInputValue = (input:HTMLInputElement, value:string) => {
    var event = new Event('input', { bubbles: true });
    input.value = value;
    input.dispatchEvent(event);
  }

  const onClickSuggestion = (suggestion:string) => {
    changeInputValue(inputRef.current!, suggestion);
    setTimeout(()=> {

      setIsShow(false);
    },200);
  };

  const setSuggestionActive = (active:number) => {
    setActive(active);
    setTimeout(()=> {
      let elements = document.getElementsByClassName('active');
      if (elements && elements.length>0) {
        const y = elements[0].getBoundingClientRect().top - autocompleteRef.current!.getBoundingClientRect().y + autocompleteRef.current!.scrollTop;
        autocompleteRef.current!.scroll({
          top: y,
          behavior: 'smooth'
        });
      }
    },100);
  }

  const onKeyDown = (e:React.KeyboardEvent<HTMLInputElement>) => {

    if (isShow) {
      if (e.keyCode === 13) { // enter key
        if (filtered[active]) {
          changeInputValue(inputRef.current!, filtered[active]);
        }
        
        setTimeout(()=> {
          setActive(0);
          setIsShow(false);
        },100);

        e.stopPropagation();
        e.preventDefault();
      }
      else if (e.keyCode === 38) { // up arrow
        return (active === 0) ? null : setSuggestionActive(active - 1);
      }
      else if (e.keyCode === 40) { // down arrow
        return (active === filtered.length-1) ? null : setSuggestionActive(active + 1);
      }
    } else {

      if(e.keyCode === 38 || e.keyCode === 40) {
        e.stopPropagation();
        e.preventDefault();
        setTimeout(()=> {
          setIsShow(true);
        },100)
      }
    }
  };

  const renderAutocomplete = () => {
    if (isShow && inputRef.current) {
      if (filtered.length || !inputRef.current.value) {
        return (
          <ul ref={autocompleteRef} className="autocomplete" data-testid={name+"-ul"}>
            {filtered.map((suggestion, index) => {
              let className;
              if (index === active) {
                className = "active";
              }
              return (
                <li data-testid={name+"-"+suggestion+"-li"} className={className} key={suggestion} onClick={() => onClickSuggestion(suggestion)}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        return (
          <div className="no-autocomplete" data-testid="no-autocomplete">
            <em>Pas de résultats</em>
          </div>
        );
      }
    }
  }
  return (

    <div className="form-group" >
      {label && <label data-testid="spb-autocomplete-label" className='textlabel' htmlFor="input-field">{label}</label>}
      <input
        ref={inputRef}
        data-testid={name}
        type="text"
        onKeyDown={onKeyDown}
        onInput={(e) => onChange(e)}
        className="form-control"
        name={name}
        placeholder={placeholder}
        defaultValue={initialValue}
        autoComplete="off"
      />
      {renderAutocomplete()}
    </div>
  );
}
